import * as React from "react";
import { SVGProps } from "react";
const SvgLogoMicrosoftTeams = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-microsoft-teams_svg__a)">
      <path
        d="M9.845 5.976A2.62 2.62 0 0 0 12.47 3.36 2.62 2.62 0 0 0 9.845.747 2.62 2.62 0 0 0 7.22 3.361a2.62 2.62 0 0 0 2.625 2.615Z"
        fill="#7B83EB"
      />
      <path
        opacity={0.1}
        d="M9.658 3.922H7.28l.012.052v.004l.013.048a2.618 2.618 0 0 0 1.17 1.565c.578.352 1.27.468 1.932.324V4.668a.747.747 0 0 0-.75-.746Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M9.095 4.481H7.473c.213.447.549.825.968 1.09.42.264.907.405 1.404.404v-.747a.747.747 0 0 0-.75-.747Z"
        fill="#000"
      />
      <path
        d="M15.751 6.162a1.965 1.965 0 0 0 1.969-1.96c0-1.083-.882-1.961-1.969-1.961a1.965 1.965 0 0 0-1.969 1.96c0 1.083.882 1.961 1.97 1.961ZM17.439 6.723h-4.422a.36.36 0 0 0-.36.358v4.543c-.012.658.203 1.3.609 1.818.406.518.979.882 1.622 1.03a2.829 2.829 0 0 0 2.353-.567 2.805 2.805 0 0 0 1.041-2.175V7.563a.839.839 0 0 0-.843-.84Z"
        fill="#5059C9"
      />
      <path
        d="M14.345 7.563v5.322c0 .986-.326 1.945-.929 2.728a4.515 4.515 0 0 1-5.29 1.412 4.491 4.491 0 0 1-2.174-1.9 4.005 4.005 0 0 1-.28-.56 4.67 4.67 0 0 1-.187-.56 4.599 4.599 0 0 1-.14-1.12V7.563a.836.836 0 0 1 .52-.777.845.845 0 0 1 .324-.063H13.5a.846.846 0 0 1 .78.518.834.834 0 0 1 .064.322Z"
        fill="#7B83EB"
      />
      <path
        opacity={0.2}
        d="M9.095 4.481H7.473c.213.447.549.825.968 1.09.42.264.907.405 1.404.404v-.747a.747.747 0 0 0-.75-.747Z"
        fill="#000"
      />
      <path
        opacity={0.1}
        d="M10.407 6.723v7.097a.737.737 0 0 1-.585.723.542.542 0 0 1-.163.022H5.671a4.67 4.67 0 0 1-.186-.56 4.599 4.599 0 0 1-.14-1.12V7.563a.836.836 0 0 1 .52-.777.845.845 0 0 1 .324-.063h4.218Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M9.845 6.723v7.657a.54.54 0 0 1-.023.163.739.739 0 0 1-.725.583H5.952a4.005 4.005 0 0 1-.28-.56 4.67 4.67 0 0 1-.187-.56 4.599 4.599 0 0 1-.14-1.121V7.563a.836.836 0 0 1 .52-.777.845.845 0 0 1 .324-.063h3.656Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M9.845 6.723v6.537a.747.747 0 0 1-.748.745H5.485a4.599 4.599 0 0 1-.14-1.12V7.563a.836.836 0 0 1 .52-.777.845.845 0 0 1 .324-.063h3.656Z"
        fill="#000"
      />
      <path
        opacity={0.2}
        d="M6.189 6.723a.845.845 0 0 0-.78.518.836.836 0 0 0-.064.322v5.322c0 .378.048.754.14 1.12h3.05a.753.753 0 0 0 .747-.745V6.723H6.19Z"
        fill="#000"
      />
      <path
        d="M1.032 4.481h7.5a.751.751 0 0 1 .75.747v7.47a.745.745 0 0 1-.75.746h-7.5a.752.752 0 0 1-.75-.746v-7.47a.745.745 0 0 1 .75-.747Z"
        fill="#4B53BC"
      />
      <path
        d="M7.021 7.268H5.34v4.493H4.236V7.268H2.544V6.165H7.02v1.103Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="logo-microsoft-teams_svg__a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoMicrosoftTeams;
